import React from 'react';
import classNames from 'classnames';
import Text from '../../../../global/text/text';

interface IProps {
    value?: string;
    children?: React.ReactNode;
    searchQuery?: string;
    cellEffectClasses?: string;
    className?: string;
    onDoubleClick?: () => void;
    wrapperTag?: keyof JSX.IntrinsicElements;
    escapeHtml?: boolean;
}

const HighlightedSearchResult = (props: IProps) => {
    const {
        searchQuery,
        value,
        cellEffectClasses,
        className,
        onDoubleClick,
        children,
        wrapperTag: WrapperTag = 'td',
        escapeHtml = false
    } = props;

    if (children) {
        return <WrapperTag className={classNames(cellEffectClasses, className)}>{children}</WrapperTag>;
    }

    return (
        <Text
            tag='td'
            className={classNames(cellEffectClasses, className)}
            onDoubleClick={onDoubleClick}
            message={value}
            highlightValue={searchQuery}
            withEllipsis
            withHighlight
            escapeHtml={escapeHtml}
        />
    );
};

export { HighlightedSearchResult };
